export default "/Frontend/dist/doc.832207d9784996e0a878143e8f112097.svg";